<script setup>
definePage({ meta: { layout: "blank" } });
// Router
const route = useRoute();
const router = useRouter();
// Check Logged In
const userData = useCookie("userData");

if (userData.value == undefined) {
  await router.push("/login");
} else {
  await router.push("/admin/dashboard");
}
</script>
<template>
  <div class="misc-wrapper">
    <div>
      <!-- 👉 Title and subtitle -->
      <div class="text-center mb-4">
        <h2 class="text-h2 font-weight-medium mb-1">Welcome to Omipos! 🚀</h2>
        <p class="mb-6">Please wait...</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
